
    import {
      getAllAccountTerminologies,
      createAccountTerminology,
      createAllAccountTerminologies,
      updateAccountTerminology,
      deleteAccountTerminology
    } from "@/services/accountTerminology";

    const state = {
      accountTerminologies: [],
      processed: false
    };

    const getters = {
      getAccountTerminologies(state) {
        return state.accountTerminologies;
      },
      accountTerminologyProcessed(state){
        return state.processed;
      }
    };

    const actions = {
      fetchAccountTerminologies({ commit }, params) {
          commit("SET_PROCESSING");
          return new Promise((resolve, reject) => {
            getAllAccountTerminologies(
              params
            )
              .then(response => {
                commit("SET_ACCOUNTTERMINOLOGIES", response.data);
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        createAccountTerminology({ commit }, accountTerminology) {
          return new Promise((resolve, reject) => {
            createAccountTerminology(accountTerminology)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        createAllAccountTerminologies({ commit }, accountTerminologies) {
          return new Promise((resolve, reject) => {
            createAllAccountTerminologies(accountTerminologies)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        updateAccountTerminology({ commit }, accountTerminology) {
          return new Promise((resolve, reject) => {
            updateAccountTerminology(accountTerminology)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        deleteAccountTerminology({ commit }, id) {
          return new Promise((resolve, reject) => {
            deleteAccountTerminology(id)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        }
      };

    const mutations = {
      SET_ACCOUNTTERMINOLOGIES(state, data) {
        state.accountTerminologies = data;
        state.processed = true;
      },
      SET_PROCESSING(state) {
        state.processed = false;
      },
      SET_PROCESSED(state) {
        state.processed = true;
      }
    };

    export default {
      state,
      getters,
      actions,
      mutations
    };
    